import React from 'react'
import { SignIn } from '../../../Components/Views'
import useAuth from '../../../Hooks/Auth'

const Render = () => {
    const { onAuth } = useAuth();
    return (
        <SignIn onSignIn={(data) => onAuth(data, '/signin')} />
    )
}

export default Render